<template>
    <va-edit-layout>
        <PayWithAmazonEventCharge-form
            :id="id"
            :title="title"
            :item="item"
        ></PayWithAmazonEventCharge-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
